// export default (url) => {
//   window.location = [
//     (process.env.RAZZLE_SITE_ENDPOINT || '//localhost:3000/').replace(/\/*$/, ''),
//     url.replace(/^\/*/, ''),
//   ].join('/');
// };

export default (url) => [
  (process.env.RAZZLE_SITE_ENDPOINT || '//localhost:3000/').replace(/\/*$/, ''),
  url.replace(/^\/*/, ''),
].join('/');
